<template>
  <div class="rate-container">
    <p class="rate-label">{{ $t('hm.label.rating.ratingTips') }}</p>
    <div class="rate-item" v-for="(item, index) in ratingList" :key="index">
      <div class="question-container">
        <span class="question-label">{{ $t('hm.label.questionLabel') }}</span>
        <div class="question-context">
          <span class="question-index">
            {{ index + 1 }}/
          </span>
          <span class="question-title">
            {{ item.question.title }}
          </span>
        </div>
      </div>
      <div class="question-container answer" v-if="showAnswer && item.question.type!==questionTypeVideo && item.question.type!==questionTypeAttachment">
        <span class="question-label">{{ $t('hm.label.answerLabel') }}</span>
        <template v-if="hasMultipleOptionQuestionType.includes(item.question.type)">
          <div class="question-context checkbox">
            <span
              class="question-title checkbox checkbox"
              v-for="(answer, index) in item.value"
              :key="index">
              {{ answer }}
            </span>
          </div>
        </template>
        <template v-else>
          <div class="question-context">
            <span class="question-title">
              {{ item.value }}
            </span>
          </div>
        </template>
      </div>
      <template v-if="item.question.type===questionTypeVideo || item.question.type===questionTypeAttachment">
        <div class="question-container question-video-container" v-if="item.question.type===questionTypeVideo">
          <span class="question-label">{{ $t('hm.resume.video') }}</span>
          <div
            class='video-link'
            @click="handelVideoPop(item)"
            target="_blank">
            <img class="video-play-icon" :src="$DjangoStaticUrl('image/video/icon_video.png')" />
          </div>
        </div>
        <div class="question-container question-attachment-container" v-if="item.question.type===questionTypeAttachment">
          <span class="question-label">{{ $t('hm.resume.attachment') }}</span>
          <a
            class="attachment-tag"
            target="_blank"
            :href="item.value"
          >
          {{ $t('hm.btn.download') }}
          </a>
        </div>
        <div class="question-container remake" >
          <span class="question-label">{{ $t('hm.resume.remark') }}</span>
          <div class="question-context">
            <span class="question-title">
              {{ item.note || '' }}
            </span>
          </div>
        </div>
      </template>
      <div class="rating">
        <span class="question-label">{{ $t('hm.label.ratingLabel') }}</span>
        <div class="rete-context">
          <el-rate
            v-model="item.rate"
            :max="6"
            :disabled="readOnly"
            :colors="['#0096cc', '#0096cc', '#0096cc']"
          ></el-rate>
          <span v-show="item.showtips && !item.rate" class="tips">{{ $t('hm.tips.pleaseRate') }}</span>
        </div>
      </div>
      <div class="comment-container">
        <span class="question-label comment-label">{{ $t('hm.label.commentLabel') }}</span>
        <el-input
          type="textarea"
          :autosize="textSize"
          resize="none"
          :readonly="readOnly"
          v-model="item.comment"
          class="title">
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { QUESTION_TYPE } from '@/constant/openQuestion'

export default {
  components: {
  },
  props: {
    ratingList: {
      require: true
    },
    readOnly: {
      default: false
    },
    showAnswer: {
      default: false
    }
  },
  data () {
    return {
      textSize: {
        minRows: 3,
        maxRows: 5
      }
    }
  },
  computed: {
    hasMultipleOptionQuestionType () {
      return [
        QUESTION_TYPE.CHECKBOX,
        QUESTION_TYPE.MULTIPLE_SELECT
      ]
    },
    questionTypeVideo () {
      return QUESTION_TYPE.VIDEO
    },
    questionTypeAttachment () {
      return QUESTION_TYPE.ATTACHMENT
    }
  },
  created () {
    _.forEach(this.ratingList, (item) => {
      this.$set(item, 'showtips', false)
    })
  },
  beforeDestroy () {

  },
  methods: {
    verifyRatingList () {
      if (this.ratingList) {
        let result = true
        _.forEach(this.ratingList, function (item) {
          if (!item.rate) {
            result = false
            item.showtips = true
          }
        })
        return result
      } else {
        return false
      }
    },
    handelVideoPop (item) {
      if (!item || !item.question?.title || !item.value?.private_mp4_url) {
        return
      }
      const params = {
        title: item.question.title,
        private_mp4_url: item.value.private_mp4_url
      }
      this.$emit('videoPop', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-container {
  .rate-item {
    background-color: #FFFFFF;
    margin-top: 15px;
    padding: 40px;

    &> div {
      display: flex;
      align-items: flex-end;
      padding: 0 0 30px 0;
    }

    .question-label {
      width: 100px;
      max-width: 100px;
      margin-right: 30px;
      flex: 1;
      word-break: keep-all;
      white-space: nowrap;
    }

    .question-container {
      display: flex;
      align-items: baseline;
      .question-context {
        flex: 10;

        .question-index {
          font-size: 24px;
        }
      }

      &.answer {
        align-items: flex-start;
        .question-context {
          &.checkbox {
            display: flex;
            flex-direction: column;
          }

          .question-title {
            margin-bottom: 15px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      &.question-video-container {
        display: flex;
        align-items: center;
        .video-link {
          background-image: url($baseDomain + 'static/image/video/video_bg.png');
          background-size: 100% 100%;
          width: 120px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;

          .video-play-icon {
            height: 36px;
          }
        }
      }

      &.question-attachment-container {
        display: flex;
        align-items: center;

        .attachment-tag {
          color: #0096cc;
        }

        .attachment-img {
          width: 30px;
        }
      }
    }

    .rating {
      justify-content: space-between;
      align-items: baseline;

      .rete-context {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .tips {
          color: red;
          margin: 15px 10px 0 0;
        }
      }
    }

    .comment-container {
      align-items: flex-start;
    }
  }

  ::v-deep .el-rate {
    .el-rate__item {
      .el-rate__icon {
        &::before {
          font-size: 30px;
        }
      }
    }
  }

  ::v-deep .el-textarea {
    flex: 10;
  }
}
</style>
